// src/routes/AppRoutes.jsx

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../pages/Login/Login';
import MainLayout from '../layouts/MainLayout';
import PrivateRoute from "./PrivateRoute";
import Delivery from "../pages/Delivery";


// استفاده از layout برای صفحات
const DashboardPage = () => (
    <MainLayout>
    </MainLayout>
);

const ProfilePage = () => (
    <MainLayout>
    </MainLayout>
);

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route
                path="/dashboard"
                element={
                    <PrivateRoute>
                        <DashboardPage />
                    </PrivateRoute>
                }
            />
            <Route
                path="/profile"
                element={
                    <PrivateRoute>
                        <ProfilePage />
                    </PrivateRoute>
                }
            />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/pending-delivery" element={<Delivery />} />
        </Routes>
    );
};

export default AppRoutes;